let setPatient = (patient) => dispatch => {
  dispatch({ type: 'SET_PATIENT', payload: patient })
}

export {
  setPatient
}
